import { type Guard } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { worldChampionshipTutorialAtom } from '@capsicum/socios-core';
import { useAtomValue } from 'jotai';

import { useBaseWCPledgeGuard } from './useBaseWCPledgeGuard';

export const useWCPledgeGuard: Guard = () => {
	const baseGuard = useBaseWCPledgeGuard();
	const router = useRouter();
	const hasSeenTutorial = useAtomValue(worldChampionshipTutorialAtom);

	return {
		onDenied: () => {
			if (baseGuard.status === 'denied') {
				baseGuard.onDenied();
			} else if (!hasSeenTutorial) {
				router.push('/locker-room-internationals/tutorial');
			}
		},
		status: baseGuard.status === 'allowed' && hasSeenTutorial ? 'allowed' : 'denied'
	};
};
